import React from 'react';
import s from './style.module.css';
import { cleanCourseName } from '@Util/util';
import Heading2 from '@Components/heading_2/view';

type PlayfeeProps = {
    courseName: string;
};

const Playfee = (props: PlayfeeProps) => {
    return (
        <div className={s.club_info_box}>
            <Heading2 title={`${cleanCourseName(props.courseName)}のプレー料金`} />
            <table className={s.club_info_box_playfee_table}>
                <tbody>
                    <tr className={s.fee_title}>
                        <th colSpan={3}>土日</th>
                    </tr>
                    <tr>
                        <th className={s.title}>メンバー</th>
                        <td>5,622円</td>
                    </tr>
                    <tr>
                        <th className={s.title}>ビジター</th>
                        <td>17,100円</td>
                    </tr>
                    <tr className={s.fee_title}>
                        <th colSpan={3}>平日</th>
                    </tr>
                    <tr>
                        <th className={s.title}>メンバー</th>
                        <td>5,622円</td>
                    </tr>
                    <tr>
                        <th className={s.title}>ビジター</th>
                        <td>7,530円</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Playfee;
